import {
  Button,
  createTableColumn,
  TableColumnDefinition,
  Menu,
  MenuTrigger,
  MenuItem,
  MenuList,
  MenuPopover,
  Checkbox,
} from "@fluentui/react-components";
import i18n from "i18next";
import React, { useEffect, useState } from "react";
import {
  DeleteRegular,
  EditRegular,
  LockClosedRegular,
  MoreVerticalRegular,
  PeopleTeamRegular,
} from "@fluentui/react-icons";
import { IUserBedarfPosition } from "../../../Models/IUserBedarfPosition";
import DialogDeleteBedarfe from "./DialogDeleteBedarfe";

interface IBedarfeProps {
  freigabeObjectGuid(item: string): void;
  onOpenEditDialog(item: string): void;
  onItemDeleted(): void;
  checkedItemsGuid(item: IUserBedarfPosition[]): void;
  resetChecked: boolean;
  selectedTab: string;
  allItems: IUserBedarfPosition[];
  hoveredItem: string;
}

export function BedarfeColumns(props: IBedarfeProps) {
  const [itemsToDelete, setItemsToDelete] = useState<string[]>([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState<string>("");
  const [checkedItems, setCheckedItems] = useState<IUserBedarfPosition[]>([]);

  useEffect(() => {
    setCheckedItems([]);
  }, [props.resetChecked]);
  const columns: TableColumnDefinition<IUserBedarfPosition>[] = [];
  if (props.selectedTab == i18n.t<string>("notSent")) {
    columns.push(
      createTableColumn<IUserBedarfPosition>({
        columnId: "checkboxId",
        renderHeaderCell: () => {
          return (
            <Checkbox
              checked={
                checkedItems.length != 0 &&
                props.allItems.length == checkedItems.length
              }
              onChange={(ev, data) => {
                if (data.checked == true) {
                  setCheckedItems(props.allItems);

                  props.checkedItemsGuid(props.allItems);
                } else {
                  setCheckedItems([]);
                  props.checkedItemsGuid([]);
                }
              }}
            ></Checkbox>
          );
        },
        renderCell: (item) => {
          return (
            <div>
              <Checkbox
                checked={checkedItems.includes(item)}
                onChange={(ev, data) => {
                  var newList: IUserBedarfPosition[] = [];
                  const currentCheckedItems = [...checkedItems];
                  if (data.checked) {
                    if (!currentCheckedItems.includes(item)) {
                      currentCheckedItems.push(item);
                      newList = currentCheckedItems;
                    }
                  } else {
                    newList = currentCheckedItems.filter(
                      (x: IUserBedarfPosition) =>
                        x.userBedarfGuid != item.userBedarfGuid,
                    );
                  }
                  setCheckedItems(newList);
                  props.checkedItemsGuid(newList);
                }}
                shape="circular"
              ></Checkbox>
            </div>
          );
        },
      }),
    );
  }

  columns.push(
    createTableColumn<IUserBedarfPosition>({
      columnId: "artikelId",
      compare: (a, b) => {
        if (a.artikelId && b.artikelId) {
          return a.artikelId.localeCompare(b.artikelId);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("artikelId");
      },
      renderCell: (item) => {
        return <div>{item.artikelId ? item.artikelId : item.produktId}</div>;
      },
    }),
    createTableColumn<IUserBedarfPosition>({
      columnId: "hasFreigaben",
      renderHeaderCell: () => {
        return i18n.t<string>("actions");
      },
      compare: (a) => {
        return a.hasFreigaben ? 1 : 0;
      },
      renderCell: (item) => {
        return (
          <div>
            <Button
              icon={
                item.hasFreigaben ? (
                  <PeopleTeamRegular color="#ff6600" />
                ) : (
                  <LockClosedRegular color="#ff6600" />
                )
              }
              onClick={() => {
                props.freigabeObjectGuid(item.userBedarfGuid);
              }}
              appearance="transparent"
            />
            {props.selectedTab == i18n.t<string>("notSent") && (
              <>
                <DialogDeleteBedarfe
                  onDelete={() => {
                    props.onItemDeleted();
                  }}
                  onDismiss={() => {
                    setOpenDeleteDialog("");
                  }}
                  open={
                    openDeleteDialog == item.userBedarfGuid &&
                    itemsToDelete.length != 0
                  }
                  itemsToDelete={itemsToDelete}
                />
                <Menu>
                  <MenuTrigger>
                    <Button
                      icon={<MoreVerticalRegular color="#ff6600" />}
                      appearance="transparent"
                    />
                  </MenuTrigger>
                  <MenuPopover>
                    <MenuList>
                      <MenuItem
                        icon={<EditRegular />}
                        onClick={() => {
                          props.onOpenEditDialog(item.userBedarfGuid);
                        }}
                      >
                        {i18n.t<string>("edit")}
                      </MenuItem>
                      <MenuItem
                        icon={<DeleteRegular />}
                        onClick={() => {
                          itemsToDelete.push(item.userBedarfGuid);
                          setOpenDeleteDialog(item.userBedarfGuid);
                        }}
                      >
                        {i18n.t<string>("delete")}
                      </MenuItem>
                    </MenuList>
                  </MenuPopover>
                </Menu>
              </>
            )}
          </div>
        );
      },
    }),
    createTableColumn<IUserBedarfPosition>({
      columnId: i18n.language.includes("de") ? "benennungDE" : "benennungEN",
      compare: (a, b) => {
        if (a.benennungDE && b.benennungDE) {
          return a.benennungDE.localeCompare(b.benennungDE);
        } else if (a.benennungEN && b.benennungEN) {
          return a.benennungEN.localeCompare(b.benennungEN);
        }
        return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("benennung");
      },
      renderCell: (item) => {
        return (
          <div>
            {i18n.language.includes("de") ? item.benennungDE : item.benennungEN}
          </div>
        );
      },
    }),
    createTableColumn<IUserBedarfPosition>({
      columnId: "menge",
      compare: (a, b) => {
        if (a.menge && b.menge) {
          return a.menge - b.menge;
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("menge");
      },
      renderCell: (item) => {
        return <div>{item.menge}</div>;
      },
    }),
    createTableColumn<IUserBedarfPosition>({
      columnId: "kundenReferenz",
      renderHeaderCell: () => {
        return i18n.t<string>("kundenReferenz");
      },
      renderCell: (item) => {
        return <div>{item.kundenReferenz}</div>;
      },
    }),
    createTableColumn<IUserBedarfPosition>({
      columnId: "createdBy.fullName",
      compare: (a, b) => {
        if (a.createdBy?.fullName && b.createdBy?.fullName) {
          return a.createdBy?.fullName.localeCompare(b.createdBy?.fullName);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("createdBy");
      },
      renderCell: (item) => {
        return <div>{item.createdBy?.fullName}</div>;
      },
    }),
  );

  if (
    props.selectedTab == i18n.t<string>("open") ||
    props.selectedTab == i18n.t<string>("finished")
  ) {
    columns.push(
      createTableColumn<IUserBedarfPosition>({
        columnId: "gesendetAm",
        compare: (a, b) => {
          if (a.gesendetAm && b.gesendetAm) {
            return a.gesendetAm.localeCompare(b.gesendetAm);
          } else return 0;
        },
        renderHeaderCell: () => {
          return i18n.t<string>("sentOn");
        },
        renderCell: (item) => {
          if (item.gesendetAm) {
            return <div>{new Date(item.gesendetAm).toLocaleDateString()}</div>;
          }
        },
      }),
    );
    if (props.selectedTab == i18n.t<string>("finished")) {
      columns.push(
        createTableColumn<IUserBedarfPosition>({
          columnId: "gesendetAm",
          compare: (a, b) => {
            if (a.gesendetAm && b.gesendetAm) {
              return a.gesendetAm.localeCompare(b.gesendetAm);
            } else return 0;
          },
          renderHeaderCell: () => {
            return i18n.t<string>("finishedOn");
          },
          renderCell: (item) => {
            if (item.bearbeitetAm) {
              return (
                <div>{new Date(item.bearbeitetAm).toLocaleDateString()}</div>
              );
            }
          },
        }),
        createTableColumn<IUserBedarfPosition>({
          columnId: "offerId",
          renderHeaderCell: () => {
            return i18n.t<string>("offerId");
          },
          renderCell: (item) => {
            return <div>{item.model?.offerId}</div>;
          },
        }),
      );
    }
  }

  return columns;
}
